import React, { useEffect, useState } from 'react';
import { callApi } from 'src/core/callApi';
import User from './User';
import Kpi from './Kpi';
import { Box, Button, Grid, Modal, TextField, Typography } from '@mui/material';
import { BACKGROUND_COLOR_1, BACKGROUND_COLOR_2, COLOR_SUCCESS_1, COLOR_TEXT_2 } from 'src/utils/colors';
import Enterprise from './Enterprise';

const Admin = () => {
  // const [userAllowed, setUserAllowed] = useState<Boolean>(true);
  const [dataType, setDataType] = useState<String>('user'); 
  const [showSearchbar, setShowSearchbar] = useState<boolean>(true);
  const [openPasswordModal, setOpenPasswordModal] = useState<boolean>(false);
  const adminPassword = localStorage.getItem('adminPassword') || null;
  const _window: any = window;
  const Tawk_API = _window.Tawk_API || {};

  const closeChat = () => {
    Tawk_API && Tawk_API.hideWidget && Tawk_API.hideWidget();
  };

  useEffect(()=>{
    closeChat();
  })
  
  useEffect(() => {
    if (!adminPassword) {
      setOpenPasswordModal(true);
    }
  }, []);

  const handleSaveAdminPassword = password => {
    setOpenPasswordModal(false);
    localStorage.setItem('adminPassword', password);
  };

  const ShowPasswordModal = () => {
    const [password, setPassword] = useState<string>('');
    return (
      <Modal
        open={openPasswordModal}
        // onClose={() => {
        //   setOpenPasswordModal(!openPasswordModal);
        // }}
      >
        <Box
          sx={{
            width: '50vw',
            height: '120px',
            background: '#fff',
            position: 'absolute',
            top: '40%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            padding: '30px',
            borderRadius: 4,
          }}
        >
          <Typography variant="h5">Enter The Admin Dashboard Password:</Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
            <TextField
              id="outlined-basic"
              variant="outlined"
              label="Password"
              value={password}
              onChange={e => {
                setPassword(e.target.value);
              }}
              sx={{ width: '100%' }}
            />
            <Button
              sx={{ backgroundColor: COLOR_SUCCESS_1, color: 'white' ,":hover":{backgroundColor:COLOR_SUCCESS_1} }}
              onClick={() => {
                handleSaveAdminPassword(password);
              }}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Modal>
    );
  };

  const style = {
    mainBox: {
      height: '100vh',
      width: '100vw',
      backgroundColor: BACKGROUND_COLOR_1,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    contentBox: {
      height: '90%',
      width: '95%',
      backgroundColor: BACKGROUND_COLOR_2,
      padding: '10px',
    },
    button: {
      backgroundColor: COLOR_TEXT_2,
      color: 'white',
    },
  };

  return (
    <Box sx={style.mainBox}>
      <Box sx={style.contentBox}>
        <Grid spacing={2} container sx={{ width: '100%' }} alignItems={'flex-start'}>
          <Grid item xs={12}>
            {!showSearchbar && (
              <Button
                sx={{
                  position: 'absolute',
                  top: '35px',
                  color: 'white',
                  border: '1px solid white',
                }}
                onClick={() => {
                  setShowSearchbar(true);
                }}
              >
                Back To Search
              </Button>
            )}

            {showSearchbar && dataType === 'user' &&(
              <Button
                sx={style.button}
                onClick={() => {
                  setOpenPasswordModal(true);
                }}
              >
                Reset Password
              </Button>
            )}
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
              <Box>
                <Button sx={style.button} onClick={() => setDataType('user')}>
                  User
                </Button>
                <Button sx={style.button} onClick={() => setDataType('kpi')}>
                  KPI
                </Button>
                <Button sx={style.button} onClick={() => setDataType('enterprise')}>
                  Enterprise
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
        <ShowPasswordModal />
        {dataType === 'user' && (
          <User
            adminPassword={adminPassword}
            dataType={dataType}
            showSearchbar={showSearchbar}
            setShowSearchbar={setShowSearchbar}
          />
        )}
        {dataType === 'kpi' && <Kpi adminPassword={adminPassword} />}
        {dataType === 'enterprise' && <Enterprise adminPassword={adminPassword} />}
      </Box>
    </Box>
  );
};

export default Admin;
